import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { Constants } from '../../constants';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  profile: Object;

  constructor(
    private http: HttpClient
  ) {}

  load(swid: any = false): Promise<any> {
    const profileHeader = Constants.PROFILE_AUTH_HEADER;
    const headerDict = {};

    headerDict[profileHeader] = 'true';

    if (swid) {
      headerDict[Constants.PROFILE_SWID_HEADER] = swid;
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict)
    };

    return this.http.get(Constants.PROFILE_ENDPOINT, requestOptions)
      .pipe(
        tap(profile => {
          this.profile = profile;
        }),
        catchError(error => of(error))
      ).toPromise();
  }

  /**
   * @desc Get profile from lambda getProfile
   *
   * @return {any} profile
   */
  getProfile(): any {
    return this.profile;
  }
}
